import PropTypes from 'prop-types';
import { Drawer, Box } from '@mui/material';
import NavSection from '../../../components/nav-section';
import navConfig from './config';

const NAV_WIDTH = 200;

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  return (
    <Drawer
      open={openNav}
      onClose={onCloseNav}
      ModalProps={{ keepMounted: true }}
      PaperProps={{ sx: { width: NAV_WIDTH } }}
    >
      {/* 你原本的側邊內容 */}
      <Box sx={{ p: 2 }}>
        <NavSection data={navConfig} />
      </Box>
    </Drawer>
  );
}
